import { StatusEnum } from '../models/status';

export const StatusLabelPipe = status => {
    switch (status) {
        case StatusEnum.ALL:
            return 'All';
        case StatusEnum.ACTIVE:
            return 'Active';
        case StatusEnum.DISMISSED:
            return 'Dismissed';
        default:
            return status;
    }
};
